var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6006_53728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25391 3.02441H15.47L22.2564 14.7242H15.0241L8.25391 3.02441Z",
    fill: "url(#paint0_linear_6006_53728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2566 14.7241L18.6404 20.9754H5.1001L8.72437 14.7241H22.2566Z",
    fill: "url(#paint1_linear_6006_53728)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09995 20.9755L1.5 14.7242L8.25396 3.02441L11.8782 9.29189L5.09995 20.9755Z",
    fill: "url(#paint2_linear_6006_53728)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.1001 20.9755L11.8378 14.7242H8.72437L5.1001 20.9755ZM22.2566 14.7242H15.0324L13.4432 11.9837L22.2566 14.7242ZM8.25411 3.02441L10.3379 11.9432L11.8784 9.29189L8.25411 3.02441Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6006_53728",
    x1: 8.25391,
    y1: 3.02441,
    x2: 18.0298,
    y2: 2593.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#FFD351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6006_53728",
    x1: 4397.17,
    y1: 14.7241,
    x2: 3239.88,
    y2: 2761.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#286EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#4286FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#286EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6006_53728",
    x1: 1736.12,
    y1: 3.02435,
    x2: -196.248,
    y2: 3301.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#069B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#11AA62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#069B5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6006_53728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7565,
    height: 18,
    fill: "white",
    transform: "translate(1.5 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/GoogleDrive.adff8251e43dd82caf2788a570ec32a6.svg";
export { ForwardRef as ReactComponent };